export const SHORTLIST_IMAGE_WEIGHT = 24;
export const SHORTLIST_IMAGE_HEIGHT = 24;
export const SHARE_IMAGE_WEIGHT = 28;
export const SHARE_IMAGE_HEIGHT = 28;
export const MORE_IMAGE_WEIGHT = 18;
export const MORE_IMAGE_HEIGHT = 4;
export const PROCESS_RESULT_TITLE_REPORT_ERROR_SUCCESS = 'Submission Sent!';
export const PROCESS_RESULT_TITLE_REPORT_ERROR_FAIL = 'Error Occurred';
export const PROCESS_RESULT_MESSAGE_REPORT_ERROR_SUCCESS = 'Thank you for bringing the error to our attention.\nRest assured, our team will investigate this matter promptly.'; // @suppress longLineCheck
export const PROCESS_RESULT_MESSAGE_REPORT_ERROR_FAIL = '';
